(function () {
  angular
    .module("akitabox.ui.dialogs.request.reopen")
    .factory("ReopenRequestDialog", ReopenRequestDialog);

  /* @ngInject */
  function ReopenRequestDialog($log, $q, $mdDialog, $mdMedia) {
    var modal = {
      templateUrl:
        "app/core/ui/dialogs/request/reopen/reopen-request.dialog.html",
      controller: "ReopenRequestDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog, `options.locals.requestIDs` and `options.locals.building` are required
     *
     * @param  {Object}                 options     Dialog options
     * @return {Promise<Object|Error}               Promise that resolves with the reopened requests
     */
    function show(options) {
      // Verify we have requests
      if (
        !options ||
        !options.locals ||
        !options.locals.requests ||
        !options.locals.requests.length > 0
      ) {
        $log.error("ReopenRequestDialog: you must pass in requests via locals");
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
